import httpManager from "@/app/shared/utils/httpManager";

export async function requestChangePlan(data) {
  const response = await httpManager.post("/customers/plan-config/upgrade-downgrade-request/", data);
  return response.data;
}
